// extracted by mini-css-extract-plugin
export default {"root":"EditListingTypeOfBusinessPanel_root__oS9dQ","form":"EditListingTypeOfBusinessPanel_form__jO0-p","title":"EditListingTypeOfBusinessPanel_title__K3hjb"};